import ListItemButton from '@mui/material/ListItemButton';
import Link from 'next/link';
import useMenuSlugParser from 'hooks/useMenuSlugParser';
import fonts from '../../../../../styles/theme/fonts';
import { MenuItem } from '../../../../../generated/graphql';
import { ExpandableMenuList } from './ExpandableMenuList';

type ListItemLinkProps = {
    slug: string;
    title: string;
    items: MenuItem[];
    isProductCategories?: boolean;
    level?: number;
};

export function ListItemLink({
    slug,
    title,
    items,
    isProductCategories,
    level = 0,
}: ListItemLinkProps) {
    const stopRenderingSubCategories = isProductCategories && level >= 1;
    const { parseSlug } = useMenuSlugParser();

    if (!items?.length || stopRenderingSubCategories) {
        return (
            <Link href={parseSlug(slug)}>
                <ListItemButton
                    sx={{
                        paddingLeft: level,
                        cursor: 'pointer',
                        textTransform: 'capitalize',
                        fontFamily: fonts.notoSans,
                    }}
                >
                    <span dangerouslySetInnerHTML={{ __html: title.toLowerCase() }} />
                </ListItemButton>
            </Link>
        );
    }

    return (
        <ExpandableMenuList
            title={title}
            level={level}
            sx={{ paddingLeft: level, cursor: 'pointer', fontFamily: fonts.notoSans }}
            slug={slug}
        >
            {items.map((item, index) => (
                <ListItemLink
                    key={index}
                    isProductCategories={isProductCategories}
                    level={level + 1}
                    {...item}
                />
            ))}
        </ExpandableMenuList>
    );
}
